import { PureComponent } from "react";
import { componentStyles } from "./cluster-selection-signup-item-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import QuoteComponent from "components/core/boards-and-quotes-carousel/quote/quote-component";
import CloseIcon from "/static/svg/icons/close.svg";

export default class ClusterSelectionSignupItemComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, imgSrc, color, onClick, activeQuote } = this.props;
    const componentStyle = { borderColor: color };

    return (
      <div className="cluster-selection-signup-item-component" style={componentStyle}>
        <div className="close-icon-wrapper" onClick={onClick}>
          <CloseIcon />
        </div>

        <div className="header">
          <PictureComponent className="image" src={imgSrc} alt={title} />
          <div className="title">{title}</div>
        </div>

        <div className="signup-form-wrapper">
          <SignupFormComponent
            buttonColor="brand-iris"
            ctaText="Start now"
            useCtaText={true}
            forceHorizontal={true}
            focusOnLoad={true}
          />
        </div>

        <div className="quote-component-wrapper">
          <QuoteComponent activeQuote={activeQuote} />
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
